export class PersonInfo {
    name: string;
    contactNumber1: string;
    contactNumber2: string;
    emailId: string;
}